export default __webpack_public_path__ + "static/media/pgmico(33).6aad442e.png";